// @ts-strict-ignore
import { ArticlePositionLayerData } from '@3d-scene/layer/creator/article-position-layer-data';
import { Group, Vector3 } from 'three';
import { RGBColorValueVO, SimpleTextValueVO } from '@shared/vo/meta-element.vo';
import { ArticlePositionElement } from '../elements/article-position-element';
import { BaseLayerElementCreator } from './base-layer-element-creator';
import { NumberUtils } from '@shared/util/number-utils';
import { ProjectModel } from '@project/model/project.model';

export class ArticlePositionLayerElementCreator extends BaseLayerElementCreator {
  private validColor: RGBColorValueVO = new RGBColorValueVO(3, 192, 60);
  private invalidColor: RGBColorValueVO = new RGBColorValueVO(255, 0, 0);
  private layerData: ArticlePositionLayerData;

  constructor(projectModel: ProjectModel, layerData: ArticlePositionLayerData) {
    super(projectModel, 'articlePosition');
    this.layerData = layerData;
  }

  public createLayerElements(): Group {
    if(!this.layerData.viewInfo.leftPosition) {
      return this.createLayerGroup();
    }
    const leftElement: ArticlePositionElement = this.createLayerElement(this.layerData.viewInfo.leftPosition, true);
    const rightElement: ArticlePositionElement = this.createLayerElement(this.layerData.viewInfo.rightPosition, false);
    return this.createLayerGroup([leftElement, rightElement]);
  }

  private createLayerElement(initPosition: Vector3, createLabel: boolean): ArticlePositionElement {
    const position: Vector3 = initPosition.clone().setZ(this.layerData.dimensions.railCenterPositionZ);
    const textValue: SimpleTextValueVO = createLabel ? this.createTextValue(position) : null;
    const topFlagPosition = position.clone().add(new Vector3(0, 0, Math.abs(this.layerData.dimensions.distanceFromTopToRailCenter)));
    const bottomFlagPosition = position.clone().add(new Vector3(0, 0, -Math.abs(this.layerData.dimensions.distanceFromTopToRailCenter)));
    return new ArticlePositionElement(topFlagPosition, bottomFlagPosition, textValue, this.layerData.viewInfo.isValid);
  }

  protected createTextValue(position: Vector3): SimpleTextValueVO {
    const positionX: number = NumberUtils.getRoundedValueInMillimeters(position.x);
    const simpleTextValue: SimpleTextValueVO = new SimpleTextValueVO();
    simpleTextValue.text = positionX + ' mm';
    simpleTextValue.bgColor = this.layerData.viewInfo.isValid ? this.validColor : this.invalidColor;
    return simpleTextValue;
  }
}
